export const associationConstants = {
    GET_SETTINGS: {
        pending: 'GET_SETTINGS/pending',
        success: 'GET_SETTINGS/success',
        rejected: 'GET_SETTINGS/rejected',
    },
};
